import { DOCUMENT, NgClass } from '@angular/common';
import {
	AfterViewInit,
	Component,
	ElementRef,
	inject,
	input,
	OnDestroy,
	output,
	viewChild,
} from '@angular/core';
import { HeadlineComponent } from '../headline/headline.component';
import { IconModule } from '../icon/icon.module';
import { overlayAnimations } from './overlay.animations';

@Component({
	selector: 'ui-overlay',
	templateUrl: 'overlay.component.html',
	imports: [IconModule, HeadlineComponent, NgClass],
	animations: overlayAnimations,
})
export class OverlayComponent implements OnDestroy, AfterViewInit {
	private readonly doc = inject(DOCUMENT);
	private readonly hostEl = inject<ElementRef<HTMLElement>>(ElementRef);

	background = input<boolean>(true);
	showCloseButton = input<boolean>(true);
	dark = input<boolean>(false);
	header = input<string>('');
	autoWidth = input<boolean>(false);
	closeOnBackgroundClick = input<boolean>(false);
	styleClass = input<string>('');
	allowDefault = input<boolean>(false);
	appendToBody = input<boolean>(false);

	closeOverlay = output<void>();

	overlayWrapper = viewChild<ElementRef>('overlayWrapper');

	private appendedToBody = false;

	ngAfterViewInit(): void {
		if (this.appendToBody()) {
			const native = this.hostEl.nativeElement as HTMLElement;
			this.doc.body.appendChild(native);
			this.appendedToBody = true;
		}
		this.overlayWrapper()?.nativeElement.focus();
	}

	private isDestroyed = false;

	onClose() {
		if (this.isDestroyed) return;
		this.closeOverlay.emit();
	}

	onBackdropClick(event: Event) {
		// Only close if clicking directly on the backdrop, not on child elements
		if (event.target === event.currentTarget && this.closeOnBackgroundClick()) {
			this.onClose();
		}
	}

	onInnerClick(event: Event) {
		if (!this.allowDefault() && !(event.target instanceof HTMLAnchorElement)) {
			event.preventDefault();
		}
	}

	ngOnDestroy() {
		this.isDestroyed = true;
		if (this.appendedToBody) {
			const native = this.hostEl.nativeElement as HTMLElement;
			if (native.parentNode === this.doc.body) {
				this.doc.body.removeChild(native);
			}
		}
	}
}
